export enum TrackingEventNameEnum {
  SUBSCRIPTION_COMPLETED = 'SUBSCRIPTION_COMPLETED',
  COURSE_CHOSEN = 'COURSE_CHOSEN',
  CITY_CHOSEN = 'CITY_CHOSEN',
  POLO_CHOSEN = 'POLO_CHOSEN',
  EVALUATION_TYPE_CHOSEN = 'EVALUATION_TYPE_CHOSEN',
  EVALUATION_SENT = 'EVALUATION_SENT',
  USER_APPLICATION_STATUS = 'USER_APPLICATION_STATUS',
  REQUEST_NEW_SIGN_IN_CODE = 'REQUEST_NEW_SIGN_IN_CODE',
  PAGE_VIEW = 'PAGE_VIEW',
  SCREEN_VIEWED = 'SCREEN_VIEWED',
}
